import React from "react";
import Content from "./layout/Content";

class App extends React.Component {
    render() {
        return (
            <>
                {/* <Header /> */}
                <Content />
                {/* <Sidebar /> */}
                {/* <Footer /> */}
            </>
        )
    }
}

export default App